import { useEffect, useState } from 'react'
import { fetchManagedMedia, managedMediaId } from '../lib/publicMedia'

type ResolvedMedia = {
  url: string
  loading: boolean
  error: string
}

type ManagedMediaState = ResolvedMedia & { reference: string }

export function useResolvedMedia(reference: string, enabled = true): ResolvedMedia {
  const [state, setState] = useState<ManagedMediaState>({ reference: '', url: '', loading: false, error: '' })
  const mediaId = managedMediaId(reference)

  useEffect(() => {
    if (!enabled || !mediaId) return

    const controller = new AbortController()
    let objectUrl = ''
    fetchManagedMedia(reference, controller.signal)
      .then((blob) => {
        objectUrl = URL.createObjectURL(blob)
        setState({ reference, url: objectUrl, loading: false, error: '' })
      })
      .catch((error: unknown) => {
        if (controller.signal.aborted) return
        setState({
          reference,
          url: '',
          loading: false,
          error: error instanceof Error ? error.message : 'Media could not be loaded',
        })
      })

    return () => {
      controller.abort()
      if (objectUrl) URL.revokeObjectURL(objectUrl)
    }
  }, [enabled, mediaId, reference])

  if (!enabled || !reference) return { url: '', loading: false, error: '' }
  if (!mediaId) return { url: reference, loading: false, error: '' }
  if (state.reference !== reference) return { url: '', loading: true, error: '' }
  return state
}
